import {
  GET_FILTERS_LIST_FULFILLED,
  FiltersActionTypes,
  FiltersState,
  GET_FILTERS_LIST,
  GET_FILTERS_PENDING,
  GET_FILTERS_FULFILLED,
  DELETE_FILTERS_FULFILLED,
  SELECT_FILTERS,
  OPEN_FILTERS_CREATE_PAGE,
  CLOSE_FILTERS_CREATE_PAGE,
  OPEN_FILTERS_EDIT_PAGE,
  CLOSE_FILTERS_EDIT_PAGE,
  CREATE_FILTERS_FULFILLED,
  SET_FILTERS_LOADING,
  CREATE_FILTERS_PENDING,
} from './filters.types';

export const initialState: FiltersState = {
  entities: [],
  single: null,
  selected: [],
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isEditPopupOpen: false,
    isLoading: false,
  },
};

export default function filtersReducer(
  state = initialState,
  action: FiltersActionTypes,
): FiltersState {
  switch (action.type) {
    case GET_FILTERS_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_FILTERS_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_FILTERS_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_FILTERS_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_FILTERS:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_FILTERS_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_FILTERS_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_FILTERS_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case OPEN_FILTERS_CREATE_PAGE:
      return {
        ...state,
        single: null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_FILTERS_CREATE_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case OPEN_FILTERS_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: true,
        },
      };

    case CLOSE_FILTERS_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: false,
        },
      };

    case SET_FILTERS_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
